import { DefaultAvailability, DefaultRecurringAvailability } from "./availability";


export const OnSchedDefaults = {
  DefaultAvailability,
  DefaultRecurringAvailability
}
